import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IServerSettings } from '../models/serversettings';
import { StorageManagerService } from './storage-manager.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SettingsService {
  private loadingSource = new BehaviorSubject<boolean>(false);
  isLoading = this.loadingSource.asObservable();

  public serverSettings: any;
  ddBrowserRum;

    constructor(private readonly httpService: HttpClient, 
        private ngzone: NgZone, private storageManagerService: StorageManagerService) { }

    getSettings(): IServerSettings {
        return this.serverSettings;
    }

    get identityServiceUrl() {
        return this.serverSettings.IdentityServiceUrl;
    }

    get sessionTimout() {
        return this.serverSettings.SessionTimeout;
    }

    get absoluteSessionTimeout() {
        return this.serverSettings.AbsoluteSessionTimeout;
    }

    get maxIdTokeIatOffsetAllowedInSeconds() {
      return this.serverSettings.MaxIdTokenIatOffsetAllowedInSeconds;
    }

    get submissionDashboardAutoRefreshDays() {
      return this.serverSettings.SubmissionDashboardAutoRefreshDays;
  }
    get splHistoryDashBoardAutoRefreshDays() {
      return this.serverSettings.SPLHistoryDashBoardAutoRefreshDays;
    }

    get pragmaticValidatorAutoRefreshDays() {
      return this.serverSettings.PragmaticValidatorAutoRefreshDays;
    }

    get silentRenewOffsetInSeconds() {
      return this.serverSettings.SilentRenewOffsetInSeconds;
    }

    // Flag for turning on/off DataDog RUM monitor
    get dataDogEnabled() {
        return this.serverSettings.DataDogEnabled;
    }

    // DataDog application ID
    get dataDogApplicationId() {
        return this.serverSettings.DataDogApplicationId;
    }

    // DataDog Client Token
    get dataDogClientToken() {
        return this.serverSettings.DataDogClientToken;
    }

    // DataDog Service Name
    get DataDogService() {
        return this.serverSettings.DataDogService;
    }

    // DataDog Site url
    get dataDogSite() {
        return this.serverSettings.DataDogSite;
    }

    // DataDog version
    get dataDogVersion() {
        return this.serverSettings.DataDogVersion;
    }

    // DataDog environment
    get dataDogEnv() {
        return this.serverSettings.DataDogEnv;
    }

    // DataDog Sample Rate
    get dataDogSampleRate() {
        return this.serverSettings.DataDogSampleRate;
    }

    // DataDog TrackInteractions flag
    get dataDogTrackInteractions() {
        return this.serverSettings.DataDogTrackInteractions;
    }

    // DataDog allowedTracingOrigins flag
    get dataDogAllowedTracingOrigins() {
      return this.serverSettings.DataDogAllowedTracingOrigins;
  }

  // Initialize datadog script element
  async initDataDogScriptElement() {
    // set datadog script element
    this.ddBrowserRum = await import(/* webpackChunkName: "datadog-browser-rum" */'@datadog/browser-rum');
  }

  // Initialize DataDog monitering service
  initDataDogRUM() {
    // Init DataDog monitoring service if the flag is on
    const bIsDataDogEnabled = this.dataDogEnabled && this.dataDogEnabled.toString().toLowerCase() === 'true' ? true : false;
    if (bIsDataDogEnabled) {
      this.ddBrowserRum.datadogRum?.init({
        applicationId: this.dataDogApplicationId,
        clientToken: this.dataDogClientToken,
        site: this.dataDogSite,
        service: this.DataDogService,
        env: this.dataDogEnv,
        version: this.dataDogVersion,
        sampleRate: this.dataDogSampleRate ? + this.dataDogSampleRate : 100,  // set default to 100%
        silentMultipleInit: true,
        trackInteractions: this.dataDogTrackInteractions && this.dataDogTrackInteractions.toString().toLowerCase() === 'true' ? true : false,
        allowedTracingOrigins: this.dataDogAllowedTracingOrigins ? this.dataDogAllowedTracingOrigins.replace(/ /g, '').split(',') : []
      });
    }
  }

  public getCustomerGuid(): string {
    let customerGuid = null;
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');
    if (currentCustomerStr) {
        const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
        if (currentCustomer) {
            customerGuid = currentCustomer.customerGuid;
        }
    }
    return customerGuid;
    } 
    
    public getUserDataName(): string {
        let userData = this.storageManagerService.read('userData');
        let name = userData ? userData.name : '';

        return name;
    }

  UpdateLoading(value: boolean) {
    this.loadingSource.next(value);
  }

}
